import { __assign, __extends } from "tslib";
/**
 * @description path，路径图，用于绘制无序的线图
 */
import * as _ from '@antv/util';
import Element from './base';
import { splitData } from './util/split-data';
import LineShapeFactory from './shape/line';
var Path = /** @class */ (function (_super) {
    __extends(Path, _super);
    function Path(cfg) {
        var _this = _super.call(this, __assign({ type: 'path', shapeType: 'line', connectNulls: false, showSinglePoint: false }, cfg)) || this;
        _this.set('shapeFactory', LineShapeFactory); // 设置 path 对应的 shapeFactory
        return _this;
    }
    /**
     * @override
     * 构造绘制 path 需要的属性
     * @param obj 数据
     */
    Path.prototype.getDrawCfg = function (obj) {
        var drawCfg = _super.prototype.getDrawCfg.call(this, obj);
        var isStack = this.hasAdjust('stack');
        return __assign(__assign({}, drawCfg), { isStack: isStack, showSinglePoint: this.get('showSinglePoint') });
    };
    Path.prototype.draw = function (data, container, shapeFactory, index) {
        var _this = this;
        var splitArray = splitData(data, this.get('connectNulls'), this.getYScale().field);
        var cfg = this.getDrawCfg(data[0]);
        cfg.origin = data; // path,line 等图的 origin 是整个数据序列
        _.each(splitArray, function (subData, splitedIndex) {
            if (!_.isEmpty(subData)) {
                cfg.splitedIndex = splitedIndex; // 传入分割片段索引 用于生成id
                cfg.points = subData;
                var geomShape = shapeFactory.drawShape(cfg.shape, cfg, container);
                _this.appendShapeInfo(geomShape, index + splitedIndex);
            }
        });
    };
    return Path;
}(Element));
export default Path;
//# sourceMappingURL=path.js.map